import styled, {css} from "styled-components"

interface Props {
  addHighlight: boolean
}

const SortOption = styled.div<Props>`
  ${({theme}) => css`
    border-bottom: 1px solid ${theme.colors.primary2_50};
    &:first-child {
      border-top-left-radius: ${theme.border.radius.small};
      border-top-right-radius: ${theme.border.radius.small};
    }
    &:last-child {
      border-bottom-left-radius: ${theme.border.radius.small};
      border-bottom-right-radius: ${theme.border.radius.small};
    }
    padding: ${theme.spacing.two};
  `}
  font-size: 14px;
  cursor: pointer;
  letter-spacing: 0.2px;
  background: ${({addHighlight, theme}) => {
    const {colors} = theme
    return addHighlight ? colors.primary2 : colors.utility.white
  }};

  &:hover {
    background: ${({addHighlight, theme}) => !addHighlight && theme.colors.primary2_50};
  }
  ${({theme}) => theme.mediaQueries.minWidthMedia.desktop`
    border-color: transparent;
  `}
`

export default SortOption
